var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report"},[_c('div',{staticClass:"header"},[_c('Header')],1),_c('div',{staticClass:"p-3"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }